
import { i18n_t } from '@utils/i18n';

const $t = i18n_t;

export const quickAccessTypes = () => ({
    Account: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'users', color: '#BB25AC' },
            routeName: 'AccountDetails',
            routeIdParam: 'accountId',
            label: $t('Account'),
        },
    },
    Dashboard: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'dashboard', color: '#E6416A' },
            routeName: 'Dashboard',
            routeIdParam: 'id',
            label: $t('Dashboard'),
        },
    },
    Feature: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'feature', color: '#8029E9' },
            routeName: 'FeatureDetails',
            routeIdParam: 'featureId',
            label: $t('Feature'),
        },
    },
    Guide: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'message-square', color: '#009855' },
            routeName: 'GuideDetails',
            routeIdParam: 'guideId',
            label: $t('Guide'),
        },
        NPS: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'heart', color: '#f64343' },
            routeName: 'GuideDetails',
            routeIdParam: 'guideId',
            label: $t('NPS'),
        },
    },
    Page: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'file', color: '#8029E9' },
            routeName: 'PageDetails',
            routeIdParam: 'pageId',
            label: $t('Page'),
        },
    },
    Report: {
        'Funnel': {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'funnels', color: '#4546E0' },
            routeName: 'FunnelDetails',
            routeIdParam: 'reportId',
            label: $t('Funnel'),
            plainLabel: 'Funnel',
        },
        'Path': {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'event-property', color: '#d035c1' },
            routeName: 'PathDetails',
            routeIdParam: 'reportId',
            label: $t('Path'),
            plainLabel: 'Path',
        },
        'Retention': {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'retention-2', color: '#4546E0' },
            routeName: 'RetentionDetails',
            routeIdParam: 'reportId',
            label: $t('Retention'),
            plainLabel: 'Retention',
        },
        'Saved Reports': {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'area-chart', color: '#4ab0d0' },
            routeName: 'DataExplorer',
            routeIdParam: 'id',
            label: $t('Data Explorer'),
            plainLabel: 'Data Explorer',
        },
        'AI Agent': {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'area-chart', color: '#4ab0d0' },
            routeName: 'AiAgentReport',
            routeIdParam: 'reportId',
            label: $t('AI Agent'),
            plainLabel: 'AI agent',
        },
    },
    Roadmap: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'roadmap', color: '#0182B6' },
            routeName: 'Roadmap',
            routeIdParam: 'roadmapId',
            label: $t('Roadmap'),
        },
    },
    SavedView: {
        feedback: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'listen', color: '#0182B6' },
            routeName: 'ValidateFeedbackSavedViewTabs',
            routeIdParam: 'savedviewId',
            label: $t('Saved view'),
        },
        replaylibrary: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'replay', color: '#550ED4' },
            routeName: 'ReplayLibrarySavedFilter',
            routeIdParam: 'savedFilterId',
            label: $t('Replay filter'),
        },
    },
    Survey: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'surveys', color: '#E83B3B' },
            routeName: 'SurveyDetails',
            routeIdParam: 'id',
            label: $t('Survey'),
        },
    },
    Segment: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'users', color: '#BB25AC' },
            routeName: 'Segments',
            label: $t('Segment'),
        },
    },
    TrackType: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'zap', color: '#8029E9' },
            routeName: 'TrackEventsDetails',
            routeIdParam: 'trackTypeId',
            label: $t('Track Event'),
        },
    },
    Visitor: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'users', color: '#BB25AC' },
            routeName: 'VisitorDetails',
            routeIdParam: 'visitorId',
            label: $t('Visitor'),
        },
    },
    VocItem: {
        feedback: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'listen', color: '#0182B6' },
            routeName: 'ListenFeedbackAllFeedbackView',
            label: $t('Feedback'),
        },
        idea: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'listen', color: '#0182B6' },
            routeName: 'Validate',
            label: $t('Idea'),
        },
    },
    Workflow: {
        default: {
            // eslint-disable-next-line internal-rules/no-hardcoded-colors
            icon: { name: 'workflows', color: '#4546E0' },
            routeName: 'WorkflowDetails',
            routeIdParam: 'reportId',
            label: $t('Workflow'),
        },
    },
});

export const getReportTypeLabel = (reportType) => {
    const reportTypes = quickAccessTypes().Report;
    const reportList = Object.values(reportTypes);
    const routeName = reportType === 'AI agent report' ? 'AiAgentReport' : reportType;
    const matchedReportLabel = reportList.find((report) => report.routeName === routeName)?.plainLabel;

    return matchedReportLabel || '';
};
